<template>
  <div class="row">
    <div class="col-md-12">
      <div class="panel panel-info">
        <div class="panel-heading">
          <h3 class="panel-title">Registrar Jugador</h3>
        </div>
        <div class="panel-body">
          <h3>{{player.idc}} {{player.name}} {{player.surname}}</h3>
          <div class="form-group">
            <label>Categoría</label>
            <select class="form-control" v-model="registration.category_id">
              <option></option>
              <option v-for="category in championship.categories" value="{{category.id}}">
                {{category.name}}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label>Índice</label>
            <input class="form-control" v-model="registration.handicap">
          </div>
          <div class="form-group">
            <button @click="saveRegistration" class="btn btn-primary">Guardar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import configure from '../../configure'
  import * as actions from '../../vuex/actions'
  import {
    getConfigChampionship,
    getConfigRegistrations
  } from '../../vuex/getters'

  export default {
    vuex: {
      getters: {
        championship: getConfigChampionship,
        registrations: getConfigRegistrations
      },
      actions: actions
    },
    props: {
      player: {default: ''}
    },
    data() {
      return {
        registration: {
          id: null,
          player_id: null,
          category_id: null,
          handicap: null,
          observation: ''
        },
        category_id: ''
      }
    },
    methods: {
      saveRegistration() {
        this.setLoading(true);
        this.registration.player_id = this.player.id;
        this.$http.post(
          configure.api_url + 'registrations',
          this.registration
        ).then((response) => {
          this.registration = response.data;
          this.loadConfigRegistrations();
          this.setLoading(false);
        }, (error) => {
          this.setLoading(false);
          alert('Error saving registration')
        })
      }
    }
  }
</script>

<style>

</style>



/** WEBPACK FOOTER **
 ** Registration.vue?0368b5bc
 **/